export function formatDate(dateString: string | Date): string {
  try {
    if (!dateString) return 'Fecha no disponible';
    const date = typeof dateString === 'string' ? new Date(dateString) : dateString;
    if (isNaN(date.getTime())) return 'Fecha inválida';
    return date.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch {
    return 'Error en fecha';
  }
}

export function isExpired(deadline: string | Date): boolean {
  try {
    if (!deadline) return false;
    const deadlineDate = typeof deadline === 'string' ? new Date(deadline) : deadline;
    if (isNaN(deadlineDate.getTime())) return false;
    return deadlineDate < new Date();
  } catch {
    return false;
  }
}

export function getDaysRemaining(deadline: string | Date): number {
  try {
    if (!deadline) return 0;
    const deadlineDate = typeof deadline === 'string' ? new Date(deadline) : deadline;
    if (isNaN(deadlineDate.getTime())) return 0;
    // Normalize both dates to local midnight for accurate day counting
    const deadlineLocal = new Date(deadlineDate);
    const todayLocal = new Date();
    deadlineLocal.setHours(0, 0, 0, 0);
    todayLocal.setHours(0, 0, 0, 0);
    return Math.round((deadlineLocal.getTime() - todayLocal.getTime()) / (1000 * 60 * 60 * 24));
  } catch {
    return 0;
  }
}

export function formatRelativeDate(dateString: Date | string): string {
  try {
    if (!dateString) return 'Fecha desconocida';
    const date = typeof dateString === 'string' ? new Date(dateString) : dateString;
    if (isNaN(date.getTime())) return 'Fecha inválida';

    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffHours / 24);

    if (diffHours < 1) return 'Hace unos minutos';
    if (diffHours < 24) return `Hace ${diffHours} hora${diffHours > 1 ? 's' : ''}`;
    if (diffDays < 7) return `Hace ${diffDays} día${diffDays > 1 ? 's' : ''}`;
    return date.toLocaleDateString('es-ES');
  } catch {
    return 'Fecha desconocida';
  }
}

export function generateWhatsAppLink(phone: string, campaignTitle: string): string {
  try {
    if (!phone || !campaignTitle) return '#';
    const cleanPhone = phone.replace(/\D/g, '');
    const phoneWithCountryCode = cleanPhone.startsWith('57') ? cleanPhone : `57${cleanPhone}`;
    const message = encodeURIComponent(`Hola, te contacto desde DonaApp por tu donación a la campaña ${campaignTitle}`);
    return `https://wa.me/${phoneWithCountryCode}?text=${message}`;
  } catch {
    return '#';
  }
}
